import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';
import {borderRadius, colors, fontFamily, fontSize, fontWeight, spacing} from '@/styles/tokens';

// Migrated from globals.scss `.double-card-wrapper`.
const sxCardWrapper = {
    backgroundColor: '#f5ede7', // no exact colors.* token match
    border: '2px solid #f6c091', // no exact colors.* token match
    padding: `${spacing[24]} ${spacing[20]}`,
    borderRadius: borderRadius.lg, // 0.75rem = 12px, exact match
    height: '100%'
};

// Migrated from globals.scss `.double-card-heading`.
const sxCardHeading = {
    fontFamily: fontFamily.heading,
    fontWeight: fontWeight.bold,
    color: colors.text.primary,
    fontSize: fontSize[24]
};

// Migrated from globals.scss `.double-card-content-text` (+ its `span` bullet).
const sxCardContentText = {
    fontFamily: fontFamily.body,
    fontSize: fontSize[16],
    color: colors.text.primary,
    gap: '6px', // no exact spacing-token match
    marginBottom: spacing[8],
    '& span': {
        fontWeight: fontWeight.bold,
        textWrap: 'nowrap'
    }
};

const DoubleCard = (props: any) => {
    const {heading, subheading, subheading2, data} = props;
    return (
        <Box>
            <Box className="spectrum-header-wrapper solutions">
                <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                    {heading}
                </Typography>
                <Box className={subheading !== undefined ? 'divder-wrapper' : ''}>
                    <hr className="divider-line divider-line-left" />
                </Box>
                {subheading && (
                    <Box className="sub-heading-box">
                        <Typography className="spectrum-sub-heading  color-black spacing platform-sub-heading text-align-left">
                            {subheading ? parse(subheading) : ''}
                        </Typography>
                    </Box>
                )}
                {subheading2 && (
                    <Box className="sub-heading-box">
                        <Typography className="spectrum-sub-heading bottom-space color-black spacing platform-sub-heading text-align-left">
                            {subheading2 ? parse(subheading2) : ''}
                        </Typography>
                    </Box>
                )}
            </Box>
            <Grid container spacing={4}>
                {data?.map((item: any, index: number) => (
                    <Grid item key={index + 1} md={6} xs={12}>
                        <Box sx={sxCardWrapper}>
                            <Typography component="h3" sx={sxCardHeading}>
                                {item.header}
                            </Typography>
                            <Box marginTop={1}>
                                {item.contentData?.map((subData: any, subIndex: number) => (
                                    <Typography component="p" key={subIndex + 1} sx={sxCardContentText}>
                                        <span>●</span> {subData.heading ? parse(subData.heading) : ''}
                                    </Typography>
                                ))}
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default memo(DoubleCard);
